/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![YoutubeNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABRElEQVR4nO2Vu0oDURCGTx9LwVew9SG227lEWP5ZSG2hUV/ERgshXrr4CDZiwDoI0QeIl04UQkpFvLAbkxgVMq4JNvlhYFnOme+cmTkzIczkUZIkc1y2DVY7YEGDFC0WtFnsnhUdEuuy2ttn6/1DJ18jaOd71E5JsMdlW4uiSmnoXHH51cFfjRStHEKK6qSd8xBSDSRWnxpArB5YrDl+IV4KQcSagdVuHYBtUqyw4uF3ANyEnyrku2ErK4g4TudZbJfVnp0h6maAJy+gr3g5XSTFsQPyGHzxxQigLxIcjstdoRsw2xILzpw38OeAyBZIse+tql4O1K4dgB1WbPoOM2JXrnfAaq+F3wGpHRXarK4Q1affi6KoUvpotZMFiF0MWnb2EUu6ymo1FpyQ4jyfB4q7vOfn5pgHgkY2U0hsfeB8pn/XO0CF3hqupCpNAAAAAElFTkSuQmCC)
 */
export const YoutubeNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M23.5 5.65a3.02 3.02 0 0 0-2.12-2.14C19.5 3 12 3 12 3s-7.5 0-9.38.5A3.02 3.02 0 0 0 .5 5.66C0 7.55 0 11.5 0 11.5s0 3.95.5 5.85a3.02 3.02 0 0 0 2.12 2.14C4.5 20 12 20 12 20s7.5 0 9.38-.5a3.02 3.02 0 0 0 2.12-2.15c.5-1.9.5-5.85.5-5.85s0-3.95-.5-5.85ZM9.55 15.1V7.9l6.27 3.59-6.27 3.59Z"
        className={colorClass}
      />
    </svg>
  );
};
